import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { BlogVideo as Original } from 'components/organisms'
import { BlogVideoSettings, BlogVideoFloatingSettings } from './BlogVideoSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import {
  videoDefaultProps,
  videoItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/VideoToolbarSection'
import {
  imageDefaultProps,
  imageItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const defaultProps = {
  ...imageDefaultProps(),
  ...videoDefaultProps(['autoplay']),
}

export const blogVideoItemParams = (enabled, id, blockProps, children) => ({
  ...imageItemParams(blockProps),
  ...videoItemParams(blockProps),
  pk: id,
})

export const dynamicProps = []

export const BlogVideo: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-blog-video ${props.className}`}>
        <Original
          item={blogVideoItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

BlogVideo.craft = withCraft({
  name: 'BlogVideo',
  defaultProps: defaultProps,
  settings: BlogVideoSettings,
  floatingSettings: BlogVideoFloatingSettings,
})
